import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';
import { MatSnackBar } from '@angular/material';

@Component({
  selector: 'app-liquidaciones-guardadas',
  templateUrl: './liquidaciones-guardadas.component.html',
  styleUrls: ['./liquidaciones-guardadas.component.css']
})
export class LiquidacionesGuardadasComponent implements OnInit {

  // Filtros
  filtroCuit: string = '';
  filtroEmpresa: string = '';

  // Datos
  dataSource: any[] = [];
  loading: boolean = false;

  // Paginacion
  pageSize: number = 20;
  pageIndex: number = 0;
  totalRecords: number = 0;

  constructor(
    private http: HttpClient,
    private router: Router,
    public snackBar: MatSnackBar
  ) {}

  ngOnInit() {
    this.buscar();
  }

  /**
   * Busca liquidaciones guardadas (resetea paginacion)
   */
  buscar() {
    this.pageIndex = 0;
    this.cargarPagina();
  }

  /**
   * Carga la pagina actual de liquidaciones guardadas
   */
  cargarPagina() {
    this.loading = true;
    const page = this.pageIndex + 1;

    let url = `${environment.backendUrl}/api/liquidaciones/listado?page=${page}&pageSize=${this.pageSize}`;

    if (this.filtroCuit && this.filtroCuit.trim() !== '') {
      url += `&cuit=${encodeURIComponent(this.filtroCuit.trim())}`;
    }
    if (this.filtroEmpresa && this.filtroEmpresa.trim() !== '') {
      url += `&empresa=${encodeURIComponent(this.filtroEmpresa.trim())}`;
    }

    this.http.get(url).subscribe(
      (response: any) => {
        this.dataSource = response.data || [];
        this.totalRecords = response.total || 0;
        this.loading = false;
      },
      (error) => {
        console.error('Error cargando liquidaciones guardadas:', error);
        this.snackBar.open('Error al cargar liquidaciones', 'Cerrar', { duration: 3000 });
        this.loading = false;
      }
    );
  }

  /**
   * Navega a editar una liquidacion guardada
   */
  editar(id: number) {
    this.router.navigate(['/liquidaciones'], { queryParams: { id } });
  }

  /**
   * Elimina una liquidacion guardada previa confirmacion
   */
  eliminar(item: any) {
    const confirmMsg = `¿Está seguro de eliminar la liquidación #${item.id} (${item.empresa} - ${item.cuit})?`;
    if (!confirm(confirmMsg)) {
      return;
    }

    this.http.delete(`${environment.backendUrl}/api/liquidaciones/guardada/${item.id}`)
      .subscribe(
        () => {
          this.snackBar.open(`Liquidación #${item.id} eliminada correctamente`, 'Cerrar', { duration: 3000 });
          this.cargarPagina();
        },
        (error) => {
          console.error('Error eliminando liquidación:', error);
          this.snackBar.open('Error al eliminar la liquidación', 'Cerrar', { duration: 3000 });
        }
      );
  }

  /**
   * Limpia los filtros y recarga
   */
  limpiarFiltros() {
    this.filtroCuit = '';
    this.filtroEmpresa = '';
    this.buscar();
  }

  /**
   * Ir a una pagina especifica
   */
  goToPage(page: number) {
    this.pageIndex = page;
    this.cargarPagina();
  }

  /**
   * Cambiar tamano de pagina
   */
  changePageSize(newSize: number) {
    this.pageSize = newSize;
    this.pageIndex = 0;
    this.cargarPagina();
  }

  /**
   * Obtiene numeros de pagina para el paginador
   */
  getPageNumbers(): (number | string)[] {
    const totalPages = Math.ceil(this.totalRecords / this.pageSize);
    const currentPage = this.pageIndex;
    const pages: (number | string)[] = [];

    if (totalPages <= 7) {
      for (let i = 0; i < totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage < 4) {
        for (let i = 0; i < 5; i++) {
          pages.push(i);
        }
        pages.push('...');
        pages.push(totalPages - 1);
      } else if (currentPage >= totalPages - 4) {
        pages.push(0);
        pages.push('...');
        for (let i = totalPages - 5; i < totalPages; i++) {
          pages.push(i);
        }
      } else {
        pages.push(0);
        pages.push('...');
        pages.push(currentPage - 1);
        pages.push(currentPage);
        pages.push(currentPage + 1);
        pages.push('...');
        pages.push(totalPages - 1);
      }
    }

    return pages;
  }

  /**
   * Obtiene el total de paginas
   */
  getTotalPages(): number {
    return Math.ceil(this.totalRecords / this.pageSize);
  }

  /**
   * Formatea un numero como moneda
   */
  formatCurrency(value: number): string {
    if (!value || value === 0) return '0,00';
    return value.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
}
